import { render, staticRenderFns } from "./CadastroViaConvite.vue?vue&type=template&id=dc05e2b4"
import script from "./CadastroViaConvite.vue?vue&type=script&lang=ts"
export * from "./CadastroViaConvite.vue?vue&type=script&lang=ts"
import style0 from "./CadastroViaConvite.vue?vue&type=style&index=0&id=dc05e2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports